module.exports = __webpack_public_path__ + "static/media/c5.138e9edd.png";